const KEY_MODEL_INFO = 'model-info'

export default class StorageUtil {

  static load (context, key, defaultValue = null) {
    return context.$sessionStorage.get(key, defaultValue)
  }

  static save (context, key, obj) {
    context.$sessionStorage.set(key, obj)
  }

  static remove (context, key) {
    context.$sessionStorage.remove(key)
  }

  static exists (context, key) {
    return context.$sessionStorage.hasKey(key)
  }

  static loadModelInfo (context, defaultValue = null) {
    return this.load(context, KEY_MODEL_INFO, defaultValue)
  }

  static saveModelInfo (context, modelInfo) {
    const copyModelInfo = Object.assign({}, modelInfo)
    delete copyModelInfo.figureDetail
    delete copyModelInfo.figureSummary
    this.save(context, KEY_MODEL_INFO, copyModelInfo)
  }

  static removeModelInfo (context) {
    this.remove(context, KEY_MODEL_INFO)
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js